import React from 'react';

import { Container, Header, Content } from './styles';

export default function Panel({ style, title, children, flex }) {
  return (
    <Container flex={flex} style={style}>
      <Header>{title}</Header>
      <Content>{children}</Content>
    </Container>
  );
}
